'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _i18n = require('./i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _config = require('./config');

Object.defineProperty(exports, 'getConfig', {
  enumerable: true,
  get: function get() {
    return _config.getConfig;
  }
});
Object.defineProperty(exports, 'setConfig', {
  enumerable: true,
  get: function get() {
    return _config.setConfig;
  }
});
exports['default'] = _i18n2['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/tg-i18n/dist/index.js
 ** module id = 1050
 ** module chunks = 1
 **/